<template>
  <a-table :scroll="{x: 680,y:500}" :columns="columns" :data-source="list" class="tableBox" rowKey='name' :pagination="false">
    <span
      v-for="col in ['content', 'maxValue', 'minValue','maxLimitValue','minLimitValue','maxApply','minApply','cost']"
      :slot="col"
      slot-scope="text,record"
      :key="col"
    >
    <!-- {{text === null || text === '' ? text : Number(text).toFixed(record.unit ==='MJ' || record.unit ==='Kcal' ? 0 : 2)}} -->
    <!-- {{ text === '' || text === null ? text : Number(text).toFixed(3)}} -->
      <span v-if="['content', 'maxValue', 'minValue'].includes(col)" :key="col">
        {{text || text === 0 ? text.toFixed(record.unit ==='MJ' || record.unit ==='Kcal' ? 0 : 2) : text}}
      </span>
      <span v-else>{{text || text === 0 ? text.toFixed(3) : text}}</span>
    </span>
  </a-table>
</template>
<script>
export default {
  props:{
    rowId:{
      type: String,
      default: ''
    },
    factoryId:{
      type: String,
      default: ''
    }
  },
  data(){
    return{
      list:[],
      pagination: {
        total:0,
        pageSize:10000,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({current: 1,pageSize})
        } //每页多少条
      },
      columns: [
        {
          title: '指标名称',
          dataIndex: 'nutritionName',
          width: 120,
          ellipsis: true,
        },
        // {
        //   title: '指标全称',
        //   dataIndex: 'nutritionFullName',
        //   width: 120,
        //   ellipsis: true,
        // },
        // {
        //   title: '指标代码',
        //   dataIndex: 'nutritionCode',
        //   width: 120,
        //   ellipsis: true,
        // },
        {
          title: '数值',
          dataIndex: 'content',
          scopedSlots: {customRender: 'content'},
          width: 80,
          ellipsis: true,
        },
        {
          title: '单位',
          dataIndex: 'unit',
          width: 80,
          ellipsis: true,
        },
        {
          title: '最小值',
          dataIndex: 'minValue',
          scopedSlots: {customRender: 'minValue'},
          width: 80,
          ellipsis: true,
        },
        {
          title: '最大值',
          dataIndex: 'maxValue',
          scopedSlots: {customRender: 'maxValue'},
          width: 80,
          ellipsis: true,
        },
        {
          dataIndex:'cost',
          title:'单位成本',
          scopedSlots: {customRender: 'cost'},
          ellipsis:true,
          width:120
        },

        {
          dataIndex:'minApply',
          title:'适用下限',
          scopedSlots: {customRender: 'minApply'},
          ellipsis:true,
          width:120
        },
        {
          dataIndex:'maxApply',
          title:'适用上限',
          scopedSlots: {customRender: 'maxApply'},
          ellipsis:true,
          width:100
        },
        {
          dataIndex:'minLimitValue',
          key:'minLimitValue',
          scopedSlots: {customRender: 'minLimitValue'},
          title: '极下限',
          ellipsis:true,
          width:120
        },
        {
          dataIndex:'maxLimitValue',
          key:'maxLimitValue',
          scopedSlots: {customRender: 'maxLimitValue'},
          title:'极上限',
          ellipsis:true,
          width:120
        },
      ],
    }
  },
  mounted(){
    this.getList()
  },
  methods:{
    getList(){
      // let {current=1,pageSize=10000} = pagination || this.pagination
      let params = {
        formulaId:this.rowId,
        // factoryId:this.factoryId,
        // current,size:pageSize
      }
      if(this.rowId){
        this.$http.get('/nhf-custom/archivedCustomFormula/getArchivedCustomProNutritionByProductId',{params}).then(res => {
          let {success,data} = res;
          if(success){
            // let {records,current=1,total=0} = data;
            // this.pagination.current = current
            // this.pagination.total = total
            this.list = data || []
          }else{
            this.$message.error('查询失败')
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tableBox{
  padding: 0 20px;
}
</style>
